module.exports = __webpack_public_path__ + "img/chongdian3.0b7670bf.jpg";